import { render, staticRenderFns } from "./PlanGoals.vue?vue&type=template&id=2d99b3be&scoped=true"
import script from "./PlanGoals.vue?vue&type=script&lang=js"
export * from "./PlanGoals.vue?vue&type=script&lang=js"
import style0 from "./PlanGoals.vue?vue&type=style&index=0&id=2d99b3be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d99b3be",
  null
  
)

export default component.exports